

export const GET_USER_REFERRAL = "GET_USER_REFERRAL"
export const GET_USER_REFERRAL_SUCCESS = "GET_USER_REFERRAL_SUCCESS"
export const GET_USER_REFERRAL_FAIL = "GET_USER_REFERRAL_FAIL"


export const SEND_REFERRAL_MAIL = "SEND_REFERRAL_MAIL"
export const SEND_REFERRAL_MAIL_SUCCESS = "SEND_REFERRAL_MAIL_SUCCESS"
export const SEND_REFERRAL_MAIL_FAIL = "SEND_REFERRAL_MAIL_FAIL"



export const GET_USER_REDEEMS = "GET_USER_REDEEMS"
export const GET_USER_REDEEMS_SUCCESS = "GET_USER_REDEEMS_SUCCESS"
export const GET_USER_REDEEMS_FAIL = "GET_USER_REDEEMS_FAIL"